export default function PaywallPage() {
  return (
    <div className="bg-white rounded-lg border shadow-sm p-4">paywall aqui</div>
  );
}
